import React, { useState, useEffect, useCallback } from 'react';
import '../../assets/css/common.css';
import '../../assets/css/main.css';
import '../../assets/css/adm_custom.css';
import { openAlert, openConfirm, DOC_KIND } from '../../utils/common';
import SectionContainer from '../../components/UI/SectionContainer';
import Spinner from '../../components/UI/Spinner';
import termsService from '../../services/termsService';

const TermsPage = () => {
  const [lang, setLang] = useState('ko');
  const [contentKo, setContentKo] = useState('');
  const [contentEn, setContentEn] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchTerms = async () => {
      setLoading(true);
      try {
        const result = await termsService.getTerms(DOC_KIND.TERMS);
        setContentKo(result.contentKo);
        setContentEn(result.contentEn);
      } catch (error) {
        console.log(error);
        // 서버에서 보낸 원본 메시지 우선 사용
        const errorMessage = error.response?.data?.message || error.message || '정보를 불러오는 중 오류가 발생했습니다.';
        openAlert({ title: '알림', description: errorMessage });
      } finally {
        setLoading(false);
      }
    };
    fetchTerms();
  }, []);

  // Actual save logic, triggered after confirmation
  const handleSaveConfirm = useCallback(async () => {
    setLoading(true);
    try {
      const result = await termsService.updateTerms(DOC_KIND.TERMS, contentKo, contentEn);
      openAlert({ title: '알림', description: result.message });
    } catch (error) {
      // 서버에서 보낸 원본 메시지 우선 사용
      const errorMessage = error.response?.data?.message || error.message || '약관 수정 중 오류가 발생했습니다.';
      openAlert({ title: '알림', description: errorMessage });
    } finally {
      setLoading(false);
    }
  }, [contentKo, contentEn]);

  // Expose for confirm callback
  useEffect(() => {
    window.handleSaveConfirm = handleSaveConfirm;
    return () => { delete window.handleSaveConfirm; };
  }, [handleSaveConfirm]);

  // Wrapper to show confirmation modal
  const handleSave = () => {
    openConfirm({
      title: '알림',
      description: '약관을 변경하시면 \n이전 약관에 동의해주신 회원들은 \n로그인시 약관 재동의가 필요합니다.\n약관을 변경하시겠습니까?',
      positive_method: 'handleSaveConfirm',
      positive_param: {},
      negative_method: null,
      negative_param: null,
    });
  };

  return (
    <SectionContainer title="이용약관 등록">
      <Spinner visible={loading} />
      <div className="content_area">
        <div className="notice">
          <div className="lang_tab_area">
            <div
              className={`lang_tab ${lang === "ko" ? "active" : ""}`}
              onClick={() => setLang("ko")}
            >
              한국어
            </div>
            <div
              className={`lang_tab ${lang === "en" ? "active" : ""}`}
              onClick={() => setLang("en")}
            >
              English
            </div>
          </div>
          <div className="notice_area">
            <div className="modal-content-wrap">
              {lang === "ko" && (
                <div className="lang_content active" id="ko_content">
                  <textarea
                    style={{ resize: "none", height: "550px" }}
                    id="content_ko"
                    value={contentKo}
                    onChange={(e) => setContentKo(e.target.value)}
                    placeholder="한국어 내용을 입력해주세요."
                    maxLength={50000}
                  />
                  <div className="text-muted small mt-1">
                    {contentKo.length}/50000자
                  </div>
                </div>
              )}
              {lang === "en" && (
                <div className="lang_content active" id="en_content">
                  <textarea
                    style={{ resize: "none", height: "550px" }}
                    id="content_en"
                    value={contentEn}
                    onChange={(e) => setContentEn(e.target.value)}
                    placeholder="Please enter content in English."
                    maxLength={50000}
                  />
                  <div className="text-muted small mt-1">
                    {contentEn.length}/50000자
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="notice_btn">
            <div className="add_btn" onClick={handleSave}>
              {loading ? "저장중..." : "저장하기"}
            </div>
          </div>
        </div>
      </div>
    </SectionContainer>
  );
};

export default TermsPage;
